import React from 'react';

export const RoleSubTable = props => {
    const { tbldata } = props;

    return (
        <div style={{paddingTop: "15px"}}>{tbldata}</div>
    );
};